export default "__VITE_ASSET__BLyjMUBv__"